import { render, staticRenderFns } from "./MemberBodyCurrency.vue?vue&type=template&id=46d1a971&scoped=true&"
import script from "./MemberBodyCurrency.vue?vue&type=script&lang=ts&"
export * from "./MemberBodyCurrency.vue?vue&type=script&lang=ts&"
import style0 from "./MemberBodyCurrency.vue?vue&type=style&index=0&id=46d1a971&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d1a971",
  null
  
)

export default component.exports